import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Moon, Music, GlassWater } from 'lucide-react';
export function AfterHours() {
  const features = [{
    icon: Moon,
    title: 'Late Night Vibes',
    description: 'An intimate atmosphere designed for those who thrive after dark.'
  }, {
    icon: Music,
    title: 'Curated Music',
    description: 'Handpicked playlists and resident DJs spinning eclectic sets until dawn.'
  }, {
    icon: GlassWater,
    title: 'Craft Mocktails',
    description: 'Artisan non-alcoholic cocktails crafted with premium ingredients and creativity.'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-813">
      <Header data-id="element-814" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-815">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-816">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/50 to-[#0B1014] z-10" data-id="element-817" />
          <img src="https://cdn.magicpatterns.com/uploads/va8WBqwRFPJVrp1Tyd8QNn/SnapInsta.to_684140561_18095297540328170_1227165002793297535_n.jpg" alt="After Hours" className="w-full h-full object-cover opacity-40" data-id="element-818" />
        </div>

        {/* Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-819">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-820">
            <div className="inline-block mb-6" data-id="element-821">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-822">
                3AM - 5AM • Fri - Sun
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-12 tracking-tight" data-id="element-823">
              AFTER HOURS
            </h1>

            <Link to="/book-now" data-id="element-824">
              <Button size="lg" className="min-w-[200px]" data-id="element-825">
                RESERVE TABLE
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-826">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-827" />
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 px-4 md:px-8 bg-[#0B1014]" data-id="element-828">
        <div className="max-w-7xl mx-auto" data-id="element-829">
          <div className="text-center mb-20" data-id="element-830">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-831">
              The hidden gem for industry insiders and night owls. Curated
              playlists, craft mocktails, and immersive experiences.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-832">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 p-10 text-center group hover:border-[#DDA247] transition-colors duration-300" data-id="element-833">
                <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-834">
                  <feature.icon className="w-10 h-10 text-[#DDA247]" data-id="element-835" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 tracking-wide" data-id="element-836">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-837">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-838" />
    </div>;
}